var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaw = function SvgPaw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E0F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5228 29.6434C26.6766 29.6434 18.4469 38.6812 18.4469 44.3897C18.382 46.9604 20.3517 48.4998 23.6692 48.4998C27.2637 48.4998 29.6428 46.651 32.5228 46.651C35.4323 46.651 37.8188 48.4998 41.3765 48.4998C44.6248 48.4998 46.6607 46.9618 46.6607 44.3934C46.5988 38.6886 38.3713 29.6434 32.5228 29.6434Z",
    fill: "#01878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6801 28.7156C20.9163 26.1655 18.5496 24.5082 16.4047 25.0238C14.2598 25.5394 13.1429 28.0232 13.907 30.5717C14.6708 33.1276 17.0374 34.7849 19.1824 34.2693C21.3273 33.7537 22.4388 31.2641 21.6801 28.7156ZM27.9189 27.1835C30.1927 26.585 31.3344 23.5669 30.4601 20.3061C29.5858 17.0452 27.035 15.069 24.7524 15.6015C22.4785 16.2 21.3368 19.2181 22.2112 22.479C23.087 25.6735 25.6355 27.7875 27.9189 27.1835ZM48.6462 25.0253C46.5013 24.576 44.1346 26.167 43.3708 28.717C42.607 31.2678 43.7207 33.753 45.8656 34.2686C48.0105 34.7179 50.3675 33.1269 51.1409 30.5769C51.9018 28.0232 50.7233 25.5409 48.6462 25.0253ZM37.1261 27.1835C39.3432 27.7819 41.9595 25.6735 42.8338 22.479C43.7082 19.2844 42.5668 16.1996 40.2926 15.6015C38.0756 15.0031 35.4592 17.1115 34.5849 20.3061C33.7084 23.5006 34.8501 26.5868 37.1261 27.1835Z",
    fill: "#01878E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paw.0a51638f.svg";
export { ForwardRef as ReactComponent };